import React, { createContext, useState } from 'react'
import MarkingWords from './MarkingWords'
import { useQuery } from '@tanstack/react-query'
import { getAssessmentCommentsFetch } from 'store/middlewares/assessment.crud'

const MarkingWordsPage = (props) => {
    const [isAudioMarkingMode, setIsAudioMarkingMode] = useState(false)

    const assessmentComments = useQuery({
        queryFn: async () => {
            const { data } = await getAssessmentCommentsFetch()
            return data
        }
    })

    const commonValue = {
        assessmentComments,
        isAudioMarkingMode, setIsAudioMarkingMode
    }

    return (
        <MarkingWordsContext.Provider value={commonValue}>
            <MarkingWords {...props} />
        </MarkingWordsContext.Provider>
    )
}

export const MarkingWordsContext = createContext()
export default MarkingWordsPage